import { render, staticRenderFns } from "./UserMonthRecordsList.vue?vue&type=template&id=5b015b14&scoped=true"
import script from "./UserMonthRecordsList.vue?vue&type=script&lang=js"
export * from "./UserMonthRecordsList.vue?vue&type=script&lang=js"
import style0 from "./UserMonthRecordsList.vue?vue&type=style&index=0&id=5b015b14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b015b14",
  null
  
)

export default component.exports